<!-- Road Project Management System -->
<div class="road-project-container">
  <!-- Top Toolbar -->
  <div class="top-toolbar">
    <div class="toolbar-left">
      <h2>Road Project Management</h2>
      <div class="breadcrumb">
        <span *ngIf="currentProject" (click)="backToProjects()" class="breadcrumb-item clickable">
          Projects
        </span>
        <span *ngIf="currentProject && currentSection" (click)="backToSections()" class="breadcrumb-item clickable">
          > {{ currentProject.project_name }}
        </span>
        <span *ngIf="currentSection && currentSegment" (click)="backToSegments()" class="breadcrumb-item clickable">
          > {{ currentSection.section_name }}
        </span>
        <span *ngIf="currentSegment" class="breadcrumb-item">
          > {{ currentSegment.segment_name }}
        </span>
      </div>
    </div>
    
    <div class="toolbar-right">
      <button (click)="toggleLayerManager()" class="btn-secondary">
        <i class="bi bi-layers"></i> Layers
      </button>
      <button (click)="toggleFeaturePanel()" class="btn-secondary">
        <i class="bi bi-geo-alt"></i> Features
      </button>
      <button (click)="toggleNumberingPanel()" class="btn-secondary">
        <i class="bi bi-123"></i> Numbering
      </button>
      <button (click)="toggleConflictPanel()" class="btn-secondary">
        <i class="bi bi-exclamation-triangle"></i> Conflicts
      </button>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="main-content">
    <!-- Left Sidebar -->
    <div class="left-sidebar" [class.expanded]="showLayerManager || showFeaturePanel || showNumberingPanel || showConflictPanel">
      
      <!-- Project Management Panel -->
      <div class="panel project-panel" *ngIf="viewMode === 0">
        <h3>Projects</h3>
        
        <!-- Create New Project -->
        <div class="create-form">
          <h4>Create New Project</h4>
          <div class="form-group">
            <label>Project Code:</label>
            <input [(ngModel)]="newProject.project_code" type="text" placeholder="PRJ001">
          </div>
          <div class="form-group">
            <label>Project Name:</label>
            <input [(ngModel)]="newProject.project_name" type="text" placeholder="Highway Expansion Project">
          </div>
          <div class="form-group">
            <label>Description:</label>
            <textarea [(ngModel)]="newProject.description" placeholder="Project description"></textarea>
          </div>
          <div class="form-group">
            <label>Client Name:</label>
            <input [(ngModel)]="newProject.client_name" type="text" placeholder="Department of Transportation">
          </div>
          <div class="form-group">
            <label>Start Date:</label>
            <input [(ngModel)]="newProject.start_date" type="date">
          </div>
          <div class="form-group">
            <label>End Date:</label>
            <input [(ngModel)]="newProject.end_date" type="date">
          </div>
          <button (click)="createProject()" class="btn-primary">
            <i class="bi bi-plus-circle"></i> Create Project
          </button>
        </div>

        <!-- Projects List -->
        <div class="projects-list">
          <h4>Existing Projects</h4>
          <div *ngFor="let project of projects" 
               class="project-item"
               [class.active]="currentProject?.id === project.id"
               (click)="selectProject(project)">
            <div class="project-info">
              <strong>{{ project.project_name }}</strong>
              <span class="project-code">{{ project.project_code }}</span>
            </div>
            <div class="project-details">
              <span>{{ project.client_name }}</span>
              <span>{{ project.start_date }} - {{ project.end_date }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Sections Panel -->
      <div class="panel sections-panel" *ngIf="viewMode === 1">
        <h3>Sections - {{ currentProject?.project_name }}</h3>
        
        <!-- Project Stats -->
        <div class="project-stats" *ngIf="projectStats">
          <div class="stat-item">
            <span class="stat-label">Sections:</span>
            <span class="stat-value">{{ projectStats.sections_count }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">Total Length:</span>
            <span class="stat-value">{{ projectStats.total_length | number:'1.2-2' }} km</span>
          </div>
        </div>

        <!-- Drawing Tools -->
        <div class="drawing-tools">
          <h4>Drawing Tools</h4>
          <div class="tool-buttons">
            <button (click)="startDrawing(1)" 
                    [class.active]="drawingMode === 1"
                    class="btn-tool">
              <i class="bi bi-pencil"></i> Draw Section
            </button>
            <button (click)="stopDrawing()" 
                    [class.active]="drawingMode === 0"
                    class="btn-tool">
              <i class="bi bi-cursor"></i> Select
            </button>
          </div>
        </div>

        <!-- Sections List -->
        <div class="sections-list">
          <h4>Sections ({{ sections.length }})</h4>
          <div *ngFor="let section of sections" 
               class="section-item"
               [class.active]="currentSection?.id === section.id"
               (click)="selectSection(section)">
            <div class="section-info">
              <strong>{{ section.section_name }}</strong>
              <span class="section-code">{{ section.section_code }}</span>
            </div>
            <div class="section-details">
              <span>Chainage: {{ section.start_chainage }} - {{ section.end_chainage }}</span>
              <span>Length: {{ section.total_length | number:'1.2-2' }} km</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Segments Panel -->
      <div class="panel segments-panel" *ngIf="viewMode === 2">
        <h3>Segments - {{ currentSection?.section_name }}</h3>

        <!-- Drawing Tools -->
        <div class="drawing-tools">
          <h4>Drawing Tools</h4>
          <div class="tool-buttons">
            <button (click)="startDrawing(2)" 
                    [class.active]="drawingMode === 2"
                    class="btn-tool">
              <i class="bi bi-pencil"></i> Draw Segment
            </button>
            <button (click)="splitSegmentAtPoint()" class="btn-tool">
              <i class="bi bi-scissors"></i> Split Segment
            </button>
            <button (click)="stopDrawing()" 
                    [class.active]="drawingMode === 0"
                    class="btn-tool">
              <i class="bi bi-cursor"></i> Select
            </button>
          </div>
        </div>

        <!-- Display Offset -->
        <div class="display-offset">
          <h4>Display Offset</h4>
          <div class="form-group">
            <label>Segment Offset:</label>
            <input [(ngModel)]="displayOffsets.segments" type="number" step="0.1">
            <button (click)="updateDisplayOffset('segment', currentSegment?.id || 0, displayOffsets.segments)" 
                    class="btn-small">
              Apply
            </button>
          </div>
        </div>

        <!-- Segments List -->
        <div class="segments-list">
          <h4>Segments ({{ segments.length }})</h4>
          <div *ngFor="let segment of segments" 
               class="segment-item"
               [class.active]="currentSegment?.id === segment.id"
               (click)="selectSegment(segment)">
            <div class="segment-info">
              <strong>{{ segment.segment_name }}</strong>
              <span class="segment-code">{{ segment.segment_code }}</span>
            </div>
            <div class="segment-details">
              <span>Chainage: {{ segment.start_chainage }} - {{ segment.end_chainage }}</span>
              <span>Length: {{ segment.length | number:'1.2-2' }} km</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Subsegments Panel -->
      <div class="panel subsegments-panel" *ngIf="viewMode === 3">
        <h3>Subsegments - {{ currentSegment?.segment_name }}</h3>

        <!-- Drawing Tools -->
        <div class="drawing-tools">
          <h4>Drawing Tools</h4>
          <div class="tool-buttons">
            <button (click)="startDrawing(3)" 
                    [class.active]="drawingMode === 3"
                    class="btn-tool">
              <i class="bi bi-pencil"></i> Draw Subsegment
            </button>
            <button (click)="applySubsegmentRules()" class="btn-tool">
              <i class="bi bi-magic"></i> Apply Rules
            </button>
            <button (click)="stopDrawing()" 
                    [class.active]="drawingMode === 0"
                    class="btn-tool">
              <i class="bi bi-cursor"></i> Select
            </button>
          </div>
        </div>

        <!-- Display Offset -->
        <div class="display-offset">
          <h4>Display Offset</h4>
          <div class="form-group">
            <label>Subsegment Offset:</label>
            <input [(ngModel)]="displayOffsets.subsegments" type="number" step="0.1">
            <button (click)="updateDisplayOffset('subsegment', 0, displayOffsets.subsegments)" 
                    class="btn-small">
              Apply
            </button>
          </div>
        </div>

        <!-- Subsegments List -->
        <div class="subsegments-list">
          <h4>Subsegments ({{ subsegments.length }})</h4>
          <div *ngFor="let subsegment of subsegments" 
               class="subsegment-item">
            <div class="subsegment-info">
              <strong>{{ subsegment.subsegment_name }}</strong>
              <span class="subsegment-code">{{ subsegment.subsegment_code }}</span>
            </div>
            <div class="subsegment-details">
              <span>Chainage: {{ subsegment.start_chainage }} - {{ subsegment.end_chainage }}</span>
              <span>Length: {{ subsegment.length | number:'1.2-2' }} km</span>
              <span *ngIf="subsegment.rule_based" class="rule-based">Rule-based</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Numbering Rules Panel -->
      <div class="panel numbering-panel" *ngIf="showNumberingPanel">
        <h3>Numbering Rules</h3>
        
        <!-- Auto-numbering Configuration -->
        <div class="auto-numbering-config">
          <h4>Auto-numbering Configuration</h4>
          <div class="form-group">
            <label>
              <input [(ngModel)]="autoNumberingConfig.enabled" type="checkbox">
              Enable Auto-numbering
            </label>
          </div>
          <div class="form-group">
            <label>Prefix:</label>
            <input [(ngModel)]="autoNumberingConfig.prefix" type="text">
          </div>
          <div class="form-group">
            <label>Start Number:</label>
            <input [(ngModel)]="autoNumberingConfig.startNumber" type="number">
          </div>
          <div class="form-group">
            <label>Increment:</label>
            <input [(ngModel)]="autoNumberingConfig.increment" type="number">
          </div>
          <div class="form-group">
            <label>Direction:</label>
            <select [(ngModel)]="autoNumberingConfig.direction">
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </select>
          </div>
          <button (click)="applyAutoNumbering()" class="btn-primary">
            <i class="bi bi-123"></i> Apply Auto-numbering
          </button>
        </div>

        <!-- Existing Rules -->
        <div class="numbering-rules-list">
          <h4>Existing Rules ({{ numberingRules.length }})</h4>
          <div *ngFor="let rule of numberingRules" class="rule-item">
            <div class="rule-info">
              <strong>{{ rule.rule_name }}</strong>
              <span class="rule-type">{{ rule.rule_type }}</span>
            </div>
            <div class="rule-details">
              <span>Prefix: {{ rule.prefix }}</span>
              <span>Start: {{ rule.start_number }}</span>
              <span>Increment: {{ rule.increment }}</span>
              <span>Direction: {{ rule.direction }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Feature Details Panel -->
      <div class="panel feature-details-panel" *ngIf="showFeaturePanel && selectedFeature">
        <h3>Feature Details</h3>
        <div class="feature-details">
          <div class="detail-item">
            <label>Type:</label>
            <span>{{ selectedFeature.layer?.id }}</span>
          </div>
          <div class="detail-item">
            <label>Properties:</label>
            <pre>{{ selectedFeature.properties | json }}</pre>
          </div>
        </div>
      </div>
    </div>

    <!-- Map Container -->
    <div class="map-container">
      <div #mapContainer class="maplibre-map"></div>
      
      <!-- Map Controls Overlay -->
      <div class="map-controls-overlay">
        <div class="control-group">
          <button (click)="map.zoomIn()" class="btn-control">
            <i class="bi bi-plus"></i>
          </button>
          <button (click)="map.zoomOut()" class="btn-control">
            <i class="bi bi-dash"></i>
          </button>
        </div>
        
        <div class="control-group">
          <button (click)="map.fitBounds([[60, 5], [100, 40]])" class="btn-control">
            <i class="bi bi-geo-alt"></i> India
          </button>
        </div>
      </div>
    </div>

    <!-- Right Sidebar -->
    <div class="right-sidebar" [class.expanded]="showConflictPanel">
      
      <!-- Conflict Detection Panel -->
      <div class="panel conflict-panel" *ngIf="showConflictPanel">
        <h3>Conflict Detection</h3>
        <div class="conflict-info">
          <p>Detect and resolve conflicts at road junctions and crossovers.</p>
          <button (click)="detectConflicts()" class="btn-primary">
            <i class="bi bi-search"></i> Detect Conflicts
          </button>
        </div>
      </div>

      <!-- Layer Visibility Controls -->
      <div class="panel layer-controls-panel">
        <h3>Layer Visibility</h3>
        <div class="layer-controls">
          <div class="layer-control">
            <label>
              <input type="checkbox" checked (change)="toggleLayerVisibility('sections-layer', $event)">
              Sections
            </label>
          </div>
          <div class="layer-control">
            <label>
              <input type="checkbox" checked (change)="toggleLayerVisibility('segments-layer', $event)">
              Segments
            </label>
          </div>
          <div class="layer-control">
            <label>
              <input type="checkbox" checked (change)="toggleLayerVisibility('subsegments-layer', $event)">
              Subsegments
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

